import { Box, VStack, Link, Grid, GridItem } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const navOptions = [
    {
      name: "Dashboard",
      link: "dashboard",
    },
    {
      name: "Create a job profile",
      link: "create-job-profile",
    },
    {
      name: "Create a new resume pool",
      link: "create-resume-pool",
    },
    {
      name: "Show batch operations",
      link: "batch-ops",
    },
    {
      name: "Rank resume pool to multiple job profiles",
      link: "pool-ranking"
    },
    {
      name: "Show resume pool rankings",
      link: "pool-ranking/pool-ranking-list"
    },
    {
      name: "TARM AI Search",
      link: "gen-ai",
    },
  ];
  
  return (
    <VStack id="home-container">
      <Grid templateColumns='repeat(5, 1fr)' gap={6}>
        {navOptions.map((option, index) => (
          <GridItem key={index}>
            <Link as={RouterLink} to={`${option.link}`} key={index}>
              <Box
                className="box-link"
                display="flex"
                p="3"
                justifyContent="center"
                alignItems="center"
                alignContent="center"
                borderWidth="1px"
                borderRadius="lg"
                height="200px"
                width="180px"
              >
                {option.name}
              </Box>
            </Link>
          </GridItem>
        ))}
      </Grid>
    </VStack>
  );
};

export default Home;
